

























































import {
  defineNuxtComponent,
  PropType,
  vue3Model,
  ref,
  computed,
  watch
} from '~/utils/nuxt3-migration'
import { Option } from '~/models/shared/types'
import CMakeLogo from '~/components/shared/configurable/make/CMakeLogo.vue'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { MakeLogoType } from '~/models/make'
import { defineComponentTranslations } from '~/utils/i18n'
import { useUserAgent } from '~/compositions/user-agent'

export default defineNuxtComponent({
  components: { CCustomSelect, CMakeLogo },
  model: vue3Model,
  props: {
    modelValue: {
      type: Array as PropType<number[]>,
      default: () => []
    },
    options: {
      type: Array as PropType<Option>,
      default: () => []
    },
    topMakesOptions: {
      type: Array as PropType<Option>,
      default: () => []
    },
    logoType: {
      type: String as PropType<MakeLogoType>,
      default: 'cars'
    },
    topMakesAsButtons: {
      type: Boolean,
      default: false
    },
    showMakesLogos: {
      type: Boolean,
      default: true
    },
    textField: {
      type: String,
      default: 'text'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { isPc } = useUserAgent()

    const selectedMakes = ref(props.modelValue)
    const selectRef = ref<typeof CCustomSelect>()
    const selectSearchText = ref('')

    watch(
      props => props.modelValue,
      newValue => {
        selectedMakes.value = newValue
      }
    )

    const showTopMakesButtons = computed(
      () =>
        props.topMakesAsButtons &&
        props.topMakesOptions?.length &&
        !selectSearchText.value &&
        isPc.value
    )

    function makeIsSelected(option: Option) {
      return selectedMakes.value.includes(option.value)
    }

    function onTopMakeButtonClick(option: Option) {
      if (makeIsSelected(option)) {
        selectedMakes.value = selectedMakes.value.filter(
          value => value !== option.value
        )
      } else {
        selectedMakes.value.push(option.value)
      }

      onUpdateValue(selectedMakes.value)
    }

    function onUpdateValue(value: number[]) {
      emit('update:modelValue', value)
      emit('change', value)
    }

    function clearSearchInput() {
      if (selectRef.value) {
        selectRef.value.clearSearchInput()
      }
    }

    function onSearch(text: string) {
      selectSearchText.value = text
    }

    return {
      selectRef,
      selectedMakes,
      showTopMakesButtons,
      makeIsSelected,
      onTopMakeButtonClick,
      onUpdateValue,
      onSearch,
      clearSearchInput
    }
  },
  i18n: defineComponentTranslations({
    which_make_are_you_looking_for: {
      en: 'Which make are you looking for?',
      el: 'Τι μάρκα ψάχνεις;'
    }
  })
})
